// Ajustes > Fale conosco, Indique e ganhe, Privacidade e termos.
import { useEffect, useState } from 'react';
import { BotaoCopiar } from '../../components/BotaoCopiar';
import { Alert, Share, Text, View } from 'react-native';
import { Btn, Chip, Field, Section } from '../../components/ui';
import { C, alpha } from '../../components/theme';
import { setDoc, useDoc } from '../../store/store';
import { compartilharCodigo, enviarFeedback, feedbackPorEmail, meuCodigo, usarCodigo, type MeuCodigo, type TipoFeedback } from '../../lib/indicacao';
import { contaNova } from '../../lib/plano';
import { EMAIL_SUPORTE } from '../../lib/termos';
import { Permissoes, TextoPrivacidade, TextoTermos } from '../../components/Termos';
import { brDateTime, brYmd, today } from '../../lib/date';
import { t } from '../../lib/i18n';
import { Card, Expansivel } from './comum';
import { RelatorioFalhas } from '../../components/Falha';

export function FaleConosco({ cor }: { cor: string }) {
  const [tipo, setTipo] = useState<TipoFeedback>('sugestao');
  const [texto, setTexto] = useState('');
  const [contato, setContato] = useState('');
  const [indo, setIndo] = useState(false);
  const enviar = async () => {
    if (!texto.trim() || indo) return;
    setIndo(true);
    try {
      const r = await enviarFeedback(tipo, texto, contato);
      setTexto('');
      if (r === 'ok') Alert.alert(t('Mensagem enviada. Obrigado!'), t('Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.'));
    } catch (e: any) { Alert.alert(t('Não foi possível'), String(e?.message ?? e)); }
    finally { setIndo(false); }
  };
  const dica = tipo === 'erro' ? t('Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.')
    : tipo === 'problema' ? t('Conte o que está difícil ou não funciona como deveria.') : t('Conte a sua ideia para o app ficar melhor.');
  return (<>
    <Text style={{ color: C.sub }}>{t('Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.')}</Text>
    <Card>
      <View style={{ flexDirection: 'row', gap: 8, flexWrap: 'wrap' }}>
        <Chip cor={cor} on={tipo === 'problema'} label={'😕 ' + t('Problema')} onPress={() => setTipo('problema')} />
        <Chip cor={cor} on={tipo === 'erro'} label={'🐞 ' + t('Erro')} onPress={() => setTipo('erro')} />
        <Chip cor={cor} on={tipo === 'sugestao'} label={'💡 ' + t('Sugestão')} onPress={() => setTipo('sugestao')} />
      </View>
      <Text style={{ color: C.sub, fontSize: 12 }}>{dica}</Text>
      <Field value={texto} onChangeText={setTexto} placeholder={t('Escreva aqui')} multiline maxLength={5000} style={{ minHeight: 130, textAlignVertical: 'top' }} />
      <Field value={contato} onChangeText={setContato} placeholder={t('E-mail ou WhatsApp para resposta (opcional)')} autoCapitalize="none" autoCorrect={false} maxLength={200} />
      <Btn cor={cor} disabled={!texto.trim() || indo} label={indo ? t('Enviando...') : t('Enviar')} onPress={enviar} />
      <Text style={{ color: C.sub, fontSize: 12 }}>{t('Quer mandar um print da tela? Envie por e-mail e anexe a imagem.')}</Text>
      <Btn outline cor={cor} label={'✉️ ' + t('Enviar por e-mail')} onPress={() => feedbackPorEmail(tipo, texto)} />
      <Text style={{ color: C.mute, fontSize: 11 }}>{EMAIL_SUPORTE}</Text>
    </Card>
    <RelatorioFalhas cor={cor} />
  </>);
}

export function Indicar({ cor }: { cor: string }) {
  const aj = useDoc('ajustes');
  const [meu, setMeu] = useState<MeuCodigo | null>(null);
  const [codigo, setCodigo] = useState('');
  const [msg, setMsg] = useState<{ ok: boolean; msg: string } | null>(null);
  const [indo, setIndo] = useState(false);
  const carregar = () => { setMeu(null); meuCodigo().then(setMeu); };
  useEffect(carregar, []);
  const bonusAtivo = !!aj.bonusAte && aj.bonusAte >= today();
  const podeUsar = contaNova() && !aj.indicadoPor;

  return (<>
    <Text style={{ color: C.sub }}>{t('Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.')}</Text>
    <Section t={t('Seu código')} />
    <Card>
      {!meu ? <Text style={{ color: C.sub }}>{t('Carregando...')}</Text>
        : 'erro' in meu ? (<>
          <Text style={{ color: C.sub }}>{meu.erro === 'servidor' ? t('O servidor ainda não está preparado para indicações. Tente de novo mais tarde.') : t('Sem internet. Tente de novo.')}</Text>
          <Btn outline cor={cor} label={t('Tentar de novo')} onPress={carregar} />
        </>) : (<>
          <View style={{ alignItems: 'center', padding: 14, borderRadius: 14, backgroundColor: alpha(cor, 0.14) }}>
            <Text style={{ color: C.text, fontSize: 32, fontWeight: '900', letterSpacing: 6 }} selectable>{meu.codigo}</Text>
          </View>
          <View style={{ flexDirection: 'row', gap: 10 }}>
            <Btn cor={cor} style={{ flex: 1 }} label={'📤 ' + t('Compartilhar')} onPress={() => compartilharCodigo(meu.codigo)} />
            <Btn outline cor={cor} style={{ flex: 1 }} label={'📲 WhatsApp'} onPress={() => compartilharCodigo(meu.codigo, true)} />
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'center' }}><BotaoCopiar cor={cor} texto={meu.codigo} rotulo={t('Copiar código')} /></View>
          <Text style={{ color: C.sub, fontSize: 12 }}>{meu.indicados ? t('{n} pessoa(s) já entraram com o seu código.', { n: meu.indicados }) : t('Ninguém usou o seu código ainda.')}</Text>
        </>)}
    </Card>

    {(podeUsar || bonusAtivo) && (<>
      <Section t={t('Recebeu um código?')} />
      <Card>
        {bonusAtivo ? <Text style={{ color: C.ok }}>🎁 {t('Todas as abas liberadas até {data}.', { data: brYmd(aj.bonusAte!) })}</Text> : (<>
          <Text style={{ color: C.sub, fontSize: 12 }}>{t('Vale uma vez, nos primeiros 30 dias da sua conta.')}</Text>
          <Field value={codigo} onChangeText={x => { setCodigo(x.toUpperCase()); setMsg(null); }} placeholder={t('Código de indicação')} autoCapitalize="characters" autoCorrect={false} maxLength={10} />
          {!!msg && <Text style={{ color: msg.ok ? C.ok : C.danger, fontSize: 12 }}>{msg.msg}</Text>}
          <Btn cor={cor} disabled={!codigo.trim() || indo} label={indo ? t('Aguarde...') : t('Usar o código')}
            onPress={async () => { setIndo(true); try { setMsg(await usarCodigo(codigo)); } finally { setIndo(false); } }} />
        </>)}
      </Card>
    </>)}
  </>);
}

/** 0.67.2 (texto 07 C7): três seções recolhidas (Permissões, Termos de uso, Política de privacidade); um toque abre, outro fecha. Textos iguais. */
export function Privacidade({ cor }: { cor: string }) {
  const aj = useDoc('ajustes');
  const perm = aj.aceite?.permissoes ?? {};
  return (<>
    {!!aj.aceite && <Text style={{ color: C.sub, fontSize: 12 }}>{t('Você aceitou os termos em {data}.', { data: brDateTime(aj.aceite.em) })}</Text>}
    <Expansivel titulo={t('Permissões')}>
      <Card>
        <Permissoes cor={cor} valor={perm} onChange={v => setDoc('ajustes', d => ({ ...d, aceite: d.aceite ? { ...d.aceite, permissoes: v } : d.aceite }))} />
        <Text style={{ color: C.sub, fontSize: 12 }}>{t('Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.')}</Text>
      </Card>
    </Expansivel>
    <Expansivel titulo={t('Termos de uso')}>
      <Card><TextoTermos /></Card>
    </Expansivel>
    <Expansivel titulo={t('Política de privacidade')}>
      <Card><TextoPrivacidade cor={cor} /></Card>
    </Expansivel>
  </>);
}
